import { CircleAlert, Info } from "lucide-react";
import type { ReactNode } from "react";
import { cx } from "./cx";

/** Aviso dentro do contexto (ex.: "depende da tarefa 1"). Não é toast: fica até deixar de ser verdade. */
export function Aviso({ tom = "alerta", children, className }: { tom?: "alerta" | "info"; children: ReactNode; className?: string }) {
  const Icone = tom === "alerta" ? CircleAlert : Info;
  return (
    <div role={tom === "alerta" ? "alert" : "status"}
      className={cx("flex items-start gap-2 rounded-controle px-3 py-2 text-meta",
        tom === "alerta" ? "bg-alerta-fundo text-alerta" : "bg-superficie-2 text-texto-3", className)}>
      <Icone size={14} className="mt-0.5" aria-hidden />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
